import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
} from "@angular/core";
import { AdditionalDatumInterface } from "@tae/interfaces";
import { BottomSheetService } from "src/app/services/bottomSheet/bottom-sheet.service";
import { ProductDescriptionsInterface } from "./dialog-amount.interface";
import {
  PageViewInferface,
  SetEventInterface,
} from "src/app/interfaces/tagging.interface";
import { StorageService } from "../../../services/storage.service";
import { TaggingService } from "src/app/services/tagging.service";
import { CtrlRechargeService } from "src/app/services/ctrl-recharge/ctrl-recharge.service";
/**
 * Component DialogComponent.
 *
 * @export
 * @class DialogComponent
 */
@Component({
    selector: "sn-dialog-amount",
    templateUrl: "./dialog-amount.component.html",
    styleUrls: ["./dialog-amount.component.scss"],
    standalone: false
})
export class DialogBottomSheetOverview implements OnInit, AfterViewInit {
  public data: any;

  @Input() title: string;

  @Input() amounts: AdditionalDatumInterface[];

  @Output() selected: EventEmitter<AdditionalDatumInterface> = new EventEmitter<AdditionalDatumInterface>();

  public get filters(): string[] {
    const filters = [];
    this.amounts.forEach(_item => {
      const exist = filters.includes(_item.categoriaProducto);
      if (!exist) {
        filters.push(_item.categoriaProducto);
      }
    });
    return filters;
  }

  public getList(): AdditionalDatumInterface[] {
    const filter = this.amounts.filter(_item => _item.categoriaProducto === this.filters[this.active]);
    return filter;
  }

  public active: number = 0;

  constructor(
    private bss: BottomSheetService,
    private taggingService: TaggingService,
    private storageService: StorageService,
    private ctrlRecharge: CtrlRechargeService
  ) {}

  public closeDialog(): void {
    this._selectData(undefined);
  }

  public getamount(_product: AdditionalDatumInterface): void {
    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "seleccion_monto",
      etiqueta: `monto_seleccionado_${_product.monto}`,
      canalBanco: "supermovil",
      url: "recarga_celular/seleccion_monto",
      userID: "",
    };

    this.taggingService.setEvent(action);
    this._selectData(_product);
  }

  private _selectData(_data: AdditionalDatumInterface) {
    if (this.data?.selected) {
      this.data.selected(_data);
    }
    this.selected.emit(_data);
    this.bss.hide();
  }

  public getDescription(
    _product: AdditionalDatumInterface
  ): ProductDescriptionsInterface {
    if (!_product.agregados) {
      return { description: _product.descripcion };
    }
    const [detail] = _product.agregados.packageInformation;
    const { qty, unit } = detail.internet;
    let description = `${qty}${unit} por ${detail.validPeriod}`;
    if (qty === "ilimitado") {
      description = `${unit} ${qty}s por ${detail.validPeriod}`;
    }
    const socialMedia = detail?.socialMedia?.length
      ? detail?.socialMedia
      : undefined;
    return { description, socialMedia };
  }

  ngOnInit(): void {
    if (this.data) {
      this.title = this.data?.title;
      this.amounts = this.data?.amounts;
      // console.log(this.amounts);
    }
  }

  ngAfterViewInit(): void {
    const { biller } = this.ctrlRecharge.recharge!;
    const pageView: PageViewInferface = {
      url: `recarga_celular/seleccion_monto`,
      canalBanco: "supermovil",
      titulo: "recarga_celular|seleccion_monto",
      subsection1: "recarga_celular",
      userId: "",
      marca: biller?.name || '',
      plan: biller?.category || '',
      entorno: this.storageService.get("ENV"),
      event: "PageView",
      proceso: this.data?.schedule?.process || '',
      periodicidad: this.data?.schedule?.frecuency || undefined
    };
    this.taggingService.setPageView(pageView);
  }

  tagging(_index: number, _name: string) {
    this.active = _index;
    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "seleccion_monto",
      etiqueta: _name.toLowerCase(),
      canalBanco: "supermovil",
      url: "recarga_celular/seleccion_monto",
      userID: "",
    };
    this.taggingService.setEvent(action);
  }
}
